export default __webpack_public_path__ + "static/media/flag-de.2961c114.svg";